import { Component, Inject, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { StateService } from "projects/shared-state/lib/state.service";

@Component({
  standalone: true,
  selector: "delete-pop-up",
  templateUrl: "./delete-pop-up.component.html",
  styleUrls: ["./delete-pop-up.component.scss"],
  imports: [CommonModule, MatIconModule, MatDialogModule],
})
export class DeletePopUpComponent {
  dialog = inject(MatDialogRef);
  stateService = inject(StateService);

  constructor(
    public dialogRef: MatDialogRef<DeletePopUpComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      workflowId: string | undefined;
      workflowTitle: string | undefined;
    },
  ) {}

  deleteWorkflow(): void {
    this.stateService.deleteWorkflow(this.data.workflowId);
    this.dialog.close();
  }
}
